import React, {Fragment} from 'react'

import withApiService from '../hoc/with-api-service'
import withData from '../hoc/with-data'

import CatalogueFilter from './catalogue-filter'
import CatalogueFilterLinkList from './catalogue-filter-link-list'
import CatalogueFilterCheckboxList from './catalogue-filter-checkbox-list'
import CatalogueFilterSlider from './catalogue-filter-slider'
import CatalogueBrandSearch from './catalogue-brand-search'
import CatalogueDropDown from './catalogue-drop-down'
import CatalogueCheckboxDisc from './catalogue-checkbox-disc'

const CatalogueSidebar = ({response, sidebarParams, maxPrice, setMaxPrice, filters, updateFilters, initFilters}) => {
  const {
    typeFilter,
    colorFilter,
    reasonFilter,
    seasonFilter,
    sizeFilter,
    minPriceFilter,
    maxPriceFilter,
    heelSizeFilter,
    brandFilter,
    discountedFilter
  } = filters;

  const {data} = response;

  return (
    <Fragment>
      <section className="sidebar__division">
        <div className="sidebar__catalogue-list">
          <CatalogueFilter title="Каталог" open>
            <CatalogueFilterLinkList list={data && data.type}
                                     filter={typeFilter}
                                     filterName="typeFilter"
                                     updateFilters={updateFilters.typeFilter}/>
          </CatalogueFilter>
        </div>
      </section>
      <div className="separator-150 separator-150-1"/>
      <section className="sidebar__division">
        <div className="sidebar__price">
          <CatalogueFilter title="Цена" open>
            <CatalogueFilterSlider params={sidebarParams}
                                   minPriceFilter={minPriceFilter}
                                   maxPriceFilter={maxPriceFilter}
                                   setMinPriceFilter={updateFilters.minPriceFilter}
                                   setMaxPriceFilter={updateFilters.maxPriceFilter}/>
          </CatalogueFilter>
        </div>
      </section>
      <div className="separator-150 separator-150-2"/>
      <section className="sidebar__division">
        <div className="sidebar__color">
          <CatalogueFilter title="Цвет" open>
            <CatalogueFilterLinkList list={data && data.color}
                                     filter={colorFilter}
                                     filterName="colorFilter"
                                     updateFilters={updateFilters.colorFilter}
                                     color/>
          </CatalogueFilter>
        </div>
      </section>
      <div className="separator-150 separator-150-3"/>
      <section className="sidebar__division">
        <div className="sidebar__size">
          <CatalogueFilter title="Размер" open>
            <CatalogueFilterCheckboxList list={data && data.sizes}
                                         filter={sizeFilter}
                                         filterName="sizeFilter"
                                         updateFilters={updateFilters.sizeFilter}/>
          </CatalogueFilter>
        </div>
      </section>
      <div className="separator-150 separator-150-4"/>
      <section className="sidebar__division">
        <div className="sidebar__size">
          <CatalogueFilter title="Размер каблука">
            <CatalogueFilterCheckboxList list={data && data.heelSize}
                                         filter={heelSizeFilter}
                                         filterName="heelSizeFilter"
                                         updateFilters={updateFilters.heelSizeFilter}/>
          </CatalogueFilter>
        </div>
      </section>
      <div className="separator-150 separator-150-5"/>
      <section className="sidebar__division">
        <div className="sidebar__occasion">
          <CatalogueFilter title="Повод" open>
            <CatalogueFilterLinkList list={data && data.reason}
                                     filter={reasonFilter}
                                     filterName="reasonFilter"
                                     updateFilters={updateFilters.reasonFilter}/>
          </CatalogueFilter>
        </div>
      </section>
      <div className="separator-150 separator-150-6"/>
      <section className="sidebar__division">
        <div className="sidebar__season">
          <CatalogueFilter title="Сезон" open>
            <CatalogueFilterLinkList list={data && data.season}
                                     filter={seasonFilter}
                                     filterName="seasonFilter"
                                     updateFilters={updateFilters.seasonFilter}/>
          </CatalogueFilter>
        </div>
      </section>
      <div className="separator-150 separator-150-7"/>
      <section className="sidebar__division">
        <CatalogueBrandSearch list={data && data.brand}
                              filter={brandFilter}
                              filterName="brandFilter"
                              updateFilters={updateFilters.brandFilter}/>
        <CatalogueCheckboxDisc filter={discountedFilter}
                               updateFilters={updateFilters.discountedFilter}/>
        <div className="separator-240"/>
      </section>

      <section className="sidebar__division">
        <CatalogueDropDown initFilters={initFilters}/>
      </section>
    </Fragment>
  )
};

const mapMethodsToProps = (apiService) => {
  return {
    getData: apiService.getFilters
  };
};

export default withApiService(mapMethodsToProps)(withData(CatalogueSidebar))
